import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/ship-to-school.jpg'),
    alt: 'ship to school page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'ship to school page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Fast <span>and Secure</span><span>Ship to School Services</span>',
  description:
    'Ship your belongings to school safely and affordably with our seamless services. We ensure fast delivery, secure handling, and flexible options for students everywhere.',
  image: {
    url: '/images/v2/pages/landing-pages/ship-to-school/hero-image.jpg',
    alt: 'Fast and Secure Ship to School Services'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Get Shipping to School Now' }
}

export const ourProcessSectionContent = {
  title: 'How We Help Ship to School Services Fast',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/ship-to-school/how-we-help-shipt-o-school-services-fast.png',
    alt: 'How We Help Ship to School Services Fast'
  },

  articles: [
    {
      id: 1,
      title: 'Simple Scheduling',
      description:
        'Choose your desired pickup date online, and our team will arrive at your doorstep to collect your belongings without hassle.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-school/simple-scheduling.svg',
        alt: 'Simple Scheduling'
      }
    },
    {
      id: 2,
      title: 'Secure Storage',
      description:
        'We offer secure and organized storage options to keep your items safe until they are ready to ship to school.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-school/secure-storage.svg',
        alt: 'Secure Storage'
      }
    },
    {
      id: 3,
      title: 'Hassle-Free Delivery',
      description:
        'Enjoy timely delivery to any school, dorm, or residence nationwide with our reliable logistics network.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-school/hassle-free-delivery.svg',
        alt: 'Hassle-Free Delivery'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Reliable Ship to School Shipping',
  description:
    'With ShipAndStorage, you can trust us to deliver your belongings safely, on time, and affordably. We specialize in shipping to schools, providing solutions tailored to the unique needs of students and their families.',
  image: {
    src: '/images/v2/pages/landing-pages/ship-to-school/reliable-ship-to-school-shipping.jpg',
    alt: 'Reliable Ship to School Shipping'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using Ship to School Services',

  cards: [
    {
      id: 1,
      title: 'Cost-Effective Options',
      description:
        'Our pricing plans are designed to fit every budget, offering students affordable and flexible shipping solutions.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-school/cost-effective-options.svg',
        alt: 'Cost-Effective Options'
      }
    },
    {
      id: 2,
      title: 'Stress-Free Process',
      description:
        'From packing and storage to delivery, we manage every detail, ensuring a smooth experience for students & parents.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-school/stress-free-process.svg',
        alt: 'Stress-Free Process'
      }
    },
    {
      id: 3,
      title: 'Nationwide Coverage',
      description:
        'We serve schools, dorms & residences across the United States, making our services accessible to your location.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-school/nationwide-coverage.svg',
        alt: 'Nationwide Coverage'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose ShipAndStorage for Ship to School Services?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Students Moving to Campus',
          description: "Whether you're a first-year or returning student, we make moving easy and stress-free."
        },
        {
          id: 2,
          title: 'Parents Assisting Students',
          description:
            'Parents can rely on us for convenient, secure, and affordable shipping options for their children.'
        },
        {
          id: 3,
          title: 'International Students',
          description:
            'From global shipping to local solutions, we simplify the process for international students relocating to the U.S.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-school/who-should-choose-shipandstorage-for-ship-to-school-services.jpg',
        alt: 'Who Should Choose ShipAndStorage for Ship to School Services?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Different Storage Services',

  cards: [
    {
      id: 1,
      title: 'Business Storage Solution',
      description:
        'Keep your office organized with affordable and secure storage for inventory, documents, or equipment.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-school/business-storage-solution.svg',
        alt: 'Business Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description: 'Moving to a new home? Enjoy stress-free storage solutions during your transition.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-school/moving-storage-solution.svg',
        alt: 'Moving Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description: 'Ship your luggage or boxes locally and internationally with ease and affordability.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-school/luggage-and-box-shipping-services.svg',
        alt: 'Luggage and Box Shipping Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Residential Storage Services',
      description: 'Ideal for homeowners during renovations, moves, or extended vacations.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-school/residential-storage-services.svg',
        alt: 'Residential Storage Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for Student Shipping Services',

  image: {
    url: '/images/v2/pages/landing-pages/ship-to-school/why-choose-shipandstorage-for-student-shipping-services.jpg',
    alt: 'Why Choose ShipAndStorage for Student Shipping Services'
  },

  articles: [
    {
      id: 1,
      title: 'Luggage and Box Shipping Services',
      description: 'Ship your luggage or boxes locally and internationally with ease and affordability.'
    },
    {
      id: 2,
      title: 'Transparent Pricing',
      description:
        'Enjoy competitive rates with no hidden fees. Our pricing plans are clear and designed for student budgets.'
    },
    {
      id: 3,
      title: 'Secure Handling',
      description:
        'Your belongings are stored and shipped with care, ensuring safety and reliability throughout the process.'
    },
    {
      id: 4,
      title: 'Flexible Storage Options',
      description:
        'Choose from various storage plans that fit your needs, whether you have one small box or several large items.'
    },
    {
      id: 5,
      title: 'Fast and Reliable Delivery',
      description: 'Our efficient logistics guarantee that your items arrive on time, every time, without delays.'
    },
    {
      id: 6,
      title: 'Student-Centered Solutions',
      description:
        'We focus on the unique needs of students, providing services that simplify life for them and their families.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Fast and Secure Ship to School Services',
  description:
    'Ship to school services designed for fast, reliable delivery. Affordable shipping that gets your items securely delivered to your school on time.',
  image: {
    src: '/images/v2/pages/landing-pages/ship-to-school/fast-and-secure-ship-to-school-services.png',
    alt: 'Fast and Secure Ship to School Services'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Start Shipping' }
}

export const ourPartnersSectionContent = {
  description:
    'ShipAndStorage collaborates with leading global carriers such as FedEx, DHL, and UPS to provide top-notch shipping and storage solutions.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'Established in 1971 by Frederick W. Smith, FedEx started with just 186 packages and has evolved into a global shipping powerhouse. Today, FedEx boasts a fleet of 696 aircraft and 215,000 vehicles, handling 16 million shipments daily across over 220 countries and territories. With a workforce exceeding 550,000 and more than 5,000 locations worldwide, FedEx ensures reliable and timely deliveries.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='FedEx.com' target='_blank'>FedEx.com</a> FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL Express, a key division of Deutsche Post DHL Group, is well-known for its international courier, parcel, and express mail services. As a leader in logistics, DHL manages over 1.8 billion parcels each year. Founded by Adrian Dalsey, Larry Hillblom, and Robert Lynn, DHL became a wholly-owned subsidiary of Deutsche Post in 2002 and operates in more than 220 countries, playing a crucial role in the global supply chain.',
        "<strong>Disclaimer:</strong> his page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, <a href='visit DHL.com' target='_blank'>visit DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'Founded as the American Messenger Company in Seattle in 1907 by teenagers Claude Ryan and Jim Casey, UPS rebranded to United Parcel Service (UPS) in 1919. Today, UPS ranks among the largest shipping companies worldwide, delivering 25 million packages each day. With over 500,000 employees globally, UPS serves more than 220 countries and territories, offering unparalleled global reach.',
        "Disclaimer: This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy of the information provided. For more information, <a href='visit UPS.com' target='_blank'>visit UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
